import { createContext, useContext, useState, useCallback } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token,      setToken]      = useState(() => localStorage.getItem("ar_token"));
  const [email,      setEmail]      = useState(() => localStorage.getItem("ar_email"));
  const [adminToken, setAdminToken] = useState(() => localStorage.getItem("ar_admin_token"));
  const [adminUser,  setAdminUser]  = useState(() => {
    const u = localStorage.getItem("ar_admin_user");
    return u ? JSON.parse(u) : null;
  });

  const login = useCallback((token, email) => {
    localStorage.setItem("ar_token", token);
    localStorage.setItem("ar_email", email);
    setToken(token); setEmail(email);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("ar_token");
    localStorage.removeItem("ar_email");
    setToken(null); setEmail(null);
  }, []);

  const adminLogin = useCallback((token, user) => {
    localStorage.setItem("ar_admin_token", token);
    localStorage.setItem("ar_admin_user", JSON.stringify(user));
    setAdminToken(token); setAdminUser(user);
  }, []);

  const adminLogout = useCallback(() => {
    localStorage.removeItem("ar_admin_token");
    localStorage.removeItem("ar_admin_user");
    setAdminToken(null); setAdminUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{
      token, email, isAuthenticated: !!token, login, logout,
      adminToken, adminUser, isAdmin: !!adminToken, adminLogin, adminLogout,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
